module.exports = __webpack_public_path__ + "img/photo3_1.c5ceeb93.jpg";